var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import EdButton from "@frameworks/web/components/generic/edbutton/edButton";
import * as React from "react";
import { Col, Row } from "react-bootstrap";
var PopupWatchlist = function (props) {
    var ref = React.useRef(null);
    React.useEffect(function () {
        var body = document.querySelector("body");
        body.style.overflow = props.show ? "hidden" : "auto";
        return function () {
            body.style.overflow = "auto";
        };
    }, [props.show]);
    React.useEffect(function () {
        function handleClickOutside(event) {
            if (ref.current &&
                !ref.current.contains(event.target) &&
                event.view.innerWidth - 17 >= event.clientX) {
                props.setShow(false);
            }
        }
        document.addEventListener("mousedown", handleClickOutside);
        return function () {
            document.removeEventListener("mousedown", handleClickOutside);
        };
    }, [ref]);
    return (React.createElement(React.Fragment, null,
        React.createElement("div", { className: "modal-backdrop ".concat(props.show ? "show" : "fade") }),
        React.createElement("div", { className: "modal ".concat(props.modalTitle, " ").concat(props.show ? "show" : "fade") },
            React.createElement("div", { className: "modal-dialog ".concat(props.size) },
                React.createElement("div", { className: "modal-content", ref: ref },
                    React.createElement("div", { className: "modal-header align-items-center justify-conent-between" },
                        React.createElement("div", { className: "d-flex justify-conent-between align-items-center" },
                            props.icon && React.createElement("i", { className: props.icon }),
                            props.title && (React.createElement("h5", { className: "modal-title" }, props.hasOwnProperty("title") ? props.title : ""))),
                        React.createElement("button", { type: "button", className: props.showCloseIcon ? props.closeicon : "", onClick: function () {
                                props.setShow(false);
                                setTimeout(function () {
                                    (props === null || props === void 0 ? void 0 : props.closeDropdown) && props.closeDropdown(false);
                                }, 0);
                            } },
                            React.createElement("i", { className: "" }))),
                    React.createElement("div", { className: "modal-body" }, props.children),
                    props.showFooter && (React.createElement("div", { className: "modal-footer ".concat(props.footerClassName) },
                        React.createElement(Row, null,
                            React.createElement(Col, { lg: 12 },
                                React.createElement(EdButton, __assign({ className: "small-edbutton" }, props.btnvalueleft)),
                                React.createElement(EdButton, __assign({ className: "ms-4 small-edbutton" }, props.btnvalueright)))))))))));
};
export default PopupWatchlist;
/******please note pop up designing component (do not delete) */
// create watchlist (screen no 308)
//  <PopupWatchlist
//    size={"modal-md modal-dialog-centered"}
//    icon="edel-icon-download1"
//    modalTitle={"modalwatchlist commonmodal"}
//    title="Name your Watchlist"
//    showFooter={true}
//    show={show}
//    setShow={setShow}
//    showCloseIcon={true}
//    closeicon={"edel-icon-bold-close"}
//  btnvalueleft={{
//                     value: "Cancel",
//                     btnTyp: "midnight-blue-border",
//                   }}
//                   btnvalueright={{
//                     value: "proceed",
//                     btnTyp: "midnight-blue",
//                   }}
//    children={<CreateNewWatchList />}
//  />;
//  <PopupWatchlist 321-screen
//                   size={"modal-md modal-dialog-centered"}
//                   icon="edel-icon-download1"
//                   modalTitle={"modalwatchlist commonmodal"}
//                   title="Warning"
//                   showFooter={true}
//                   show={show}
//                   setShow={setShow}
//                   showCloseIcon={true}
//                   closeicon={"edel-icon-cross"}
//                   btnvalueleft={{
//                     value: "ok",
//                     btnTyp: "midnight-blue",
//                   }}
//
